import { Builder } from '@builder.io/react'
import { Link } from 'gatsby'
import React from 'react'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'

enum ButtonAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export interface CTASixProps {
  backgroundColor: string
  buttonAlignment: ButtonAlignment
  CTAButton: LinkButtonProp
}

const CTASix = ({ backgroundColor, buttonAlignment, CTAButton }: CTASixProps) => {
  const getButtonAlignment = () => {
    let alignment = 'flex-start'
    switch (buttonAlignment) {
      case ButtonAlignment.Center: {
        alignment = 'center'
        break
      }
      case ButtonAlignment.Right: {
        alignment = 'flex-end'
        break
      }
      default: {
        alignment = 'flex-start'
        break
      }
    }
    return alignment
  }

  const alignment = getButtonAlignment()

  return (
    <div className="bg-white" style={{ backgroundColor }}>
      <div className="mx-auto max-w-7xl py-2 px-4 sm:px-4 md:py-4 lg:px-4 ">
        <div className="flex w-full" style={{ justifyContent: alignment }}>
          <Link target="_blank" rel="noopener" to={`${CTAButton?.buttonUrl}`}>
            <p className="mt-3 mb-4 text-base text-[#006685]">{`${CTAButton?.buttonText}`}</p>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CTASix

Builder.registerComponent(CTASix, {
  name: 'CTASix',
  inputs: [
    {
      name: 'buttonAlignment',
      type: 'string',
      enum: ['left', 'right', 'center'],
      defaultValue: 'center'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'CTAButton'
    }
  ]
})

export const CTASixRegisterProps = {
  name: 'buttonProps',
  type: 'object',
  defaultValue: {
    buttonAlignment: 'center',
    backgroundColor: 'lightblue',
    CTAButton: LinkButtonRegisterProps
  },
  subFields: [
    {
      name: 'buttonAlignment',
      type: 'string',
      enum: ['left', 'right', 'center'],
      defaultValue: 'center'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'CTAButton'
    }
  ]
}
